import Position from 'pages/path-finding-page/config/interfaces/Position';

export default function distanceBetweenTwoPosition(position1: Position, position2: Position) {
  return Math.sqrt(Math.pow(position1.row - position2.row, 2) + Math.pow(position1.col - position2.col, 2));
}
